document.addEventListener("DOMContentLoaded", () => {
  const /** @type HTMLDivElement */ modal_contact =
      document.getElementById("modal-contact");
  if (!modal_contact) {
    return;
  }

  modal_contact.addEventListener("shown.bs.modal", async (e) => {
    const jQuery = await import("jquery");
    await import("select2");
    const $ = jQuery.default;
    // https://stackoverflow.com/a/57204042
    $(".js-tarti-select2")
      .not(".js-tarti-select2--applied")
      .each(function (_, element) {
        $(element)
          .select2({
            theme: "tarti",
            dropdownParent: $(this).parent(),
          })
          .addClass("js-tarti-select2--applied");
      });
    // https://stackoverflow.com/a/68030102
    $(document).on("select2:open", () => {
      setTimeout(() => {
        document.querySelector(".select2-search__field").focus();
      }, 0);
    });

    $("#city").on("select2:select", function (/*event, params*/) {
      // console.log("city select", jQuery.default(this).val());
      $.ajax({
        dataType: "json",
        url:
          window.location.protocol +
          "//" +
          window.location.hostname +
          "/get-city-districts-with-ajax",
        data: {
          cityName: jQuery.default(this).val(),
          token: _globalToken._token,
        },
        type: "GET",
        success: function (data) {
          if (data.status) {
            $("#district").find("option").not('[value=""]').remove();
            $("#district").append(
              data.districts
                .map(
                  (district) =>
                    `<option value="${district.district_name}">${district.district_name}</option>`
                )
                .join("\n")
            );
          }
        },
        error: function () {
          alert("Seçilen il için ilçe verisi yüklenemedi.");
          return false;
        },
      });
    });
  });

  // begin: enlightening-text
  const enlightening_text = modal_contact.querySelector("#enlightening-text"),
  enlightening_text_content = modal_contact.querySelector("#enlightening-text-content");
  if (enlightening_text && enlightening_text_content) {
    enlightening_text.addEventListener("shown.bs.collapse", async () => {
      if("false" === enlightening_text_content.getAttribute("data-content-loaded")) {
        const contentHtml = await fetch(window.location.protocol + "//" + window.location.hostname + enlightening_text_content.dataset.contentHref).then(response => response.text());
        const cleanContent = document.createElement("div");
        cleanContent.innerHTML = contentHtml;
        if (cleanContent.querySelector(".col-md-10")) {
          enlightening_text_content.setAttribute("data-content-loaded", "true");
          enlightening_text_content.innerHTML = cleanContent.querySelector(enlightening_text_content.dataset.contentSelector).innerHTML;
        }
      }
    });
  }
  // end: enlightening-text

  // begin: phone-verification
  modal_contact.addEventListener("phone-verification", () => {
    (new window.Collapse("#phone-verification")).show();
  });
  // end: phone-verification

  // begin: contact-ok
  modal_contact.addEventListener("contact-ok", () => {
    (new window.Collapse("#phone-verification")).hide();
    (new window.Collapse("#contact-ok")).show();

    if (dataLayer) {
      /**
       * Bu olaya ait değişkenler önceden contact-form.js içinde dolduruluyor.
       */
      dataLayer.push({"event": "LetsCallYou"});
    }
  });
  // end: contact-ok
});
